<template lang="pug">
  main
    NavBar
    ModalYN(v-show="modalStatusYN" :config="configModalYN" @padre:close="borrarNominacionMensual")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-10
            h1.title
              | Nominaciones &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
          .column.is-2
              a.button.is-black.is-rounded(@click="nuevaNomMensual")
                | Nueva
        .columns.is-hidden-mobile(v-show="verFormMensual")
          .column.is-3
            b Seleccione un Grupo:
            .field
              .control
                .select.is-black
                  select(v-model="grupo")
                    option(v-for="g in grupos" :key="g.id" :value="g.id") {{ g.nombre }} - {{ g.compania }}
          .column.is-2
            b Seleccione Año:
            .field
              .control
                .select.is-black
                  select(v-model="year_nominacion")
                    option(:value="2019") 2019
                    option(:value="2020") 2020
                    option(:value="2021") 2021
                    option(:value="2022") 2022
                    option(:value="2023") 2023
                    option(:value="2024") 2024
                    option(:value="2025") 2025
                    option(:value="2026") 2026
                    option(:value="2027") 2027
                    option(:value="2028") 2028
                    option(:value="2029") 2029
                    option(:value="2030") 2030
          .column.is-2
            b Seleccione Mes:
            .field
              .control
                .select.is-black
                  select(v-model="mes_nominacion")
                    option(v-for="m in meses" :key="m.id" :value="m.id") {{ m.value }}
          .column.is-2
            .field
              label.label Nominación Mensual
              .control
                input.input.is-black(
                  type='number',
                  placeholder='Nominacion',
                  v-model="nominacion",
                  :disabled="disabledNom"
                )
          .column.is-3
            a.button.is-black.is-rounded(@click="guardarNomMensual") Guardar
            | &nbsp
            a.button.is-rounded(@click="cerraFormMensual") Cerrar
        .columns.is-hidden-tablet(v-show="verFormMensual")
          .column.is-4
            b Seleccione un Grupo:
            .field
              .control
                .select.is-black
                  select(v-model="grupo")
                    option(v-for="g in grupos" :key="g.id" :value="g.id") {{ g.nombre }} - {{ g.compania }}
          .column.is-4
            b Seleccione Año:
            .field
              .control
                .select.is-black
                  select(v-model="year_nominacion")
                    option(:value="2019") 2019
                    option(:value="2020") 2020
                    option(:value="2021") 2021
                    option(:value="2022") 2022
                    option(:value="2023") 2023
                    option(:value="2024") 2024
                    option(:value="2025") 2025
                    option(:value="2026") 2026
                    option(:value="2027") 2027
                    option(:value="2028") 2028
                    option(:value="2029") 2029
                    option(:value="2030") 2030
          .column.is-4
            b Seleccione Mes:
            .field
              .control
                .select.is-black
                  select(v-model="mes_nominacion")
                    option(v-for="m in meses" :key="m.id" :value="m.id") {{ m.value }}
        .columns.is-hidden-tablet(v-show="verFormMensual")
          .column.is-4-mobile
            .field
              label.label Nominación Mensual
              .control
                input.input.is-black(
                  type='number',
                  placeholder='Nominacion',
                  v-model="nominacion",
                  :disabled="disabledNom"
                )
        .columns.is-hidden-tablet(v-show="verFormMensual")
          .column.is-4-mobile.is-3-desktop
            a.button.is-black.is-rounded(@click="guardarNomMensual") Guardar
            | &nbsp
            a.button.is-rounded(@click="cerraFormMensual") Cerrar
        .columns(v-show="verNomMensual")
          .column
            ListOfNominacionesMensual(:updateComponente="actualizarListaMensual" @actualizarPadre="listaMesualActualizada" @genNominacionDiaria="verNominacionDiaria" @deleteNomMensual="deleteNomMensual")
        .columns(v-show="verNomDiaria")
          .column
            ListInputsFecha(:ListFechas="fechasComparadas" :dias="dias_NomDiaria" :grupo="grupo_NomDiaria" @ocultarListaDiaria="hideListaDiaria" :enabledList="isListempty" @updateNominaciones="hideListaDiaria")
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBar from './layout/NavBar.vue'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import ListInputsFecha from './componentes/ListInputsFecha.vue'
  import ListOfNominacionesMensual from './componentes/ListOfNominacionesMensual.vue'
  import nominaciones_tpaServices from '@/services/sca/nominaciones/nominacionesTpa.js'
  import sca_tuxpanServices from '@/services/sca/tpa.js'
  import ModalYN from '@/components/shared/ModalYN.vue'
  import { mapState } from "vuex"

  export default {
    name: 'NominacionesTPA',
    components: { Loader, NavBar, flatPickr, ListInputsFecha, ListOfNominacionesMensual, ModalYN },
    data() {
      return {
        isLoading: true,
        year_nominacion: '',
        mes_nominacion: '',
        grupo: '',
        nominacion: 0,
        disabledNom: false,
        grupos: [],
        meses: [
          { id: '01', value: 'ENERO'},
          { id: '02', value: 'FEBRERO'},
          { id: '03', value: 'MARZO'},
          { id: '04', value: 'ABRIL'},
          { id: '05', value: 'MAYO'},
          { id: '06', value: 'JUNIO'},
          { id: '07', value: 'JULIO'},
          { id: '08', value: 'AGOSTO'},
          { id: '09', value: 'SEPTIEMPRE'},
          { id: '10', value: 'OCTUBRE'},
          { id: '11', value: 'NOVIEMBRE'},
          { id: '12', value: 'DICIEMBRE'}
        ],
        calendario_nominacion: '',
        inicioMes: '',
        finMes: '',
        fechasArray: [],
        fechasArrayBD: [],
        fechasComparadas: [],
        actualizarListaMensual: true,
        verNomMensual: true,
        verNomDiaria: false,
        grupo_NomDiaria: '',
        dias_NomDiaria: 0,
        verFormMensual: false,
        isListempty: false,
        modalStatusYN: false,
        configModalYN: {},
        nominacionSel: {}
      }
    },
    methods: {
      iniciarComponente() {
        this.isLoading = true
        this.obtenerGrupos()
      },
      obtenerGrupos () {
        sca_tuxpanServices.getSubgrupos()
          .then(data => {
            this.grupos = data
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },
      obtenerNominacionesSim (nom) {
        this.fechasArray = []
        this.grupo_NomDiaria = nom.grupo
        let formatFecha = `${nom.anio}-${nom.mes}-01`
        this.inicioMes = moment(formatFecha).startOf('month').format('YYYY-MM-DD')
        this.finMes = moment(formatFecha).endOf('month').format('YYYY-MM-DD')
        let inicio = parseInt(this.inicioMes.substr(8,2))
        let fin = parseInt(this.finMes.substr(8,2))


        let nomdiaria = 0
        let indexStr = ''
        let fechaStr = ''
        nomdiaria = parseInt(nom.nominacion) / fin

        for (let index = inicio; index <= fin; index++) {
            if (index < 10) {
              indexStr = `0${index}`
            } else {
              indexStr = index
            }
            fechaStr = `${nom.anio}-${nom.mes}-${indexStr}`

            this.fechasArray.push({
              'fecha': fechaStr,
              'grupo': nom.unidadNeg,
              'nominacion': Math.round(nomdiaria),
              'inBD': false
            })

          }

        this.dias_NomDiaria = this.fechasArray.length
        this.generarNominacionDiaria(nom)
      },

      saveNominacionDiaria () {
        console.log('Guardar Nom')
      },

      guardarNomMensual () {
        let id = Date.now()
        nominaciones_tpaServices.guardarNom_Mensual(id, this.grupo, this.year_nominacion, this.mes_nominacion, this.nominacion)
          .then( r => {
            this.displayToast(r.success ? 'toasted-primary' : 'blubed', r.respuesta, r.success ? 'check' : 'ban', 'OK')
            this.actualizarListaMensual = r.success
            this.cerraFormMensual()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      listaMesualActualizada (valor) {
        if (valor) {
          this.actualizarListaMensual = false
        }
      },

      verNominacionDiaria (data) {
        console.log(data)
        this.verNomDiaria = true
        this.verNomMensual = false
        this.obtenerNominacionesBD(data)
      },

      obtenerNominacionesBD(nom) {
        this.fechasArrayBD = []
        let formatFecha = `${nom.anio}-${nom.mes}-01`
        console.log(formatFecha)
        this.inicioMes = moment(formatFecha).startOf('month').format('YYYY-MM-DD')
        this.finMes = moment(formatFecha).endOf('month').format('YYYY-MM-DD')
        let inicio = parseInt(this.inicioMes.substr(8,2))
        let fin = parseInt(this.finMes.substr(8,2))

        let fechaIni = `${nom.anio}-${nom.mes}-${inicio}`
        let fechafin = `${nom.anio}-${nom.mes}-${fin}`
        nominaciones_tpaServices.obtenerNominacionesMes(fechaIni, fechafin, nom.unidadNeg)
          .then( resp => {
            console.log(resp)
            if (resp.length > 0) {
              this.fechasArrayBD = resp.map(this.convertirNomBD)
              this.isListempty = false
            } else {
              this.fechasArrayBD = []
              this.isListempty = true
            }
            this.obtenerNominacionesSim(nom)
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },


      deleteNomMensual (data) {
        if (this.permisos.sca_tpa > 1) {
          return
        }
        this.nominacionSel = data
        this.configModalYN = {
          title: 'Eliminar Nominación Mensual',
          content: `¿Desea eliminar la nominacion de ${data.grupo} del ${data.anio} - ${data.mes}`,
          textCancel: 'Cancelar',
          textOk: 'Eliminar'
        }
        this.modalStatusYN = true

      },

      borrarNominacionMensual (val) {
        if (this.permisos.sca_tpa > 1) {
          return
        }
        if (val) {
          nominaciones_tpaServices.borrarNominacionMensual(this.nominacionSel.id)
          .then( r => {
            this.actualizarListaMensual = r.success
            this.isLoading = false
            this.displayToast(r.success ? 'toasted-primary' : 'blubed', r.respuesta, r.success ? 'check' : 'ban', 'OK')
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
        }
        this.nominacionSel = {}
        this.modalStatusYN = false
        this.isLoading = false
      },

      convertirNomBD (nom) {
        return {
          ...nom,
          fecha: nom.fecha_nominacion,
          grupo: nom.unidadNeg,
          nominacion: Number(nom.nominacion),
          inBD: true
        }
      },

      generarNominacionDiaria(nom) {
        this.fechasComparadas = []

        this.fechasArray.map( fGen => {
          const existe = this.fechasArrayBD.find( fBD => fBD.fecha_nominacion === fGen.fecha)
          existe ? this.fechasComparadas.push(existe) : this.fechasComparadas.push(fGen)
        })
      },

      hideListaDiaria (valor) {
        if (valor === 'c') {
          this.verNomDiaria = false
          this.verNomMensual = true
          this.fechasArray = []
          this.fechasArrayBD = []
          this.isListempty = false
        }
      },

      nuevaNomMensual () {
        if (this.permisos.sca_tpa > 1) {
          return
        }
        this.verFormMensual = true
        this.verNomMensual = false
        this.verNomDiaria = false
      },

      cerraFormMensual () {
        this.verFormMensual = false
        this.verNomMensual = true
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: tema,
          position: "bottom-right",
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage() {
        this.$router.back()
      }
    },
    computed: {
      ...mapState(["logueado", "userLogin", 'permisos'])
    },
    created () {
      this.iniciarComponente()
    },


  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/nominaciones/HomeNominaciones.vue